module.exports = __webpack_public_path__ + "img/lunbo24.6ccdbe5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/lunbo24.jpg
// module id = K2ee
// module chunks = 0